import React from 'react';
import Countries from '../../components/Countries/Countries';

const HomePage = () => (
  <section>
    <Countries />
  </section>
);

export default HomePage;
